import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import api, { formatErr } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function ChangePasswordPage() {
  const { user, refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { setErr("Passwords do not match"); return; }
    if (pw.length < 6) { setErr("Use at least 6 characters"); return; }
    setBusy(true); setErr("");
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      const u = await refreshUser();
      navigate(u.role === "client" ? `/clients/${u.client_id}` : "/dashboard", { replace: true });
    } catch (e) { setErr(formatErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 dot-grid bg-[#0A0A0A]">
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-5 tt-card p-7 anim-scale-in" data-testid="change-pw-form">
        <div>
          <div className="t-eyebrow mb-2">First-login security</div>
          <h2 className="h-display-2">Set a new password</h2>
          <p className="text-zinc-500 text-[12px] mt-1.5">Hi {user?.name}, please pick a personal password before continuing.</p>
        </div>
        <div className="space-y-3">
          <div>
            <Label className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">Current (temporary) password</Label>
            <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required
              className="bg-[#0c0c0e] border-zinc-800 focus:border-zinc-500 mt-1 h-10 text-[13px]" data-testid="change-pw-current" />
          </div>
          <div>
            <Label className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">New password</Label>
            <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required
              className="bg-[#0c0c0e] border-zinc-800 focus:border-zinc-500 mt-1 h-10 text-[13px]" data-testid="change-pw-new" />
          </div>
          <div>
            <Label className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">Confirm new password</Label>
            <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required
              className="bg-[#0c0c0e] border-zinc-800 focus:border-zinc-500 mt-1 h-10 text-[13px]" data-testid="change-pw-confirm" />
          </div>
        </div>
        {err && <div className="text-[12px] flag-red rounded-md p-2.5" data-testid="change-pw-error">{err}</div>}
        <div className="flex gap-2">
          <Button type="submit" disabled={busy} className="flex-1 h-10 bg-white hover:bg-zinc-200 text-black font-medium text-[13px]" data-testid="change-pw-submit">
            {busy ? "Saving…" : "Continue"}
          </Button>
          <Button type="button" variant="ghost" onClick={async () => { await logout(); navigate("/login"); }} className="text-zinc-500 text-[13px]">Cancel</Button>
        </div>
      </form>
    </div>
  );
}
